<template>
  <div>

    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 mt-5">
            <h3 class="card-title align-items-start flex-column text-dark">
              <span class="font-weight-bolder text-dark"
                >Prestataires</span
              >
            </h3>
            <div class="card-toolbar"></div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0 mt-n3">
            <!--begin::Table-->
            <DxDataGrid
              @initialized="saveGridInstance"
              :data-source="dataSource"
              :remote-operations="true"
              :columns="columns"
              :show-row-lines="true"
              :word-wrap-enabled="true"
              :show-borders="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="false"
              :hover-state-enabled="true"
              :column-auto-width="true"
              :show-column-lines="true"
              :selection="{ mode: 'none' }"
            >
              >
              <DxFilterRow :visible="true" />

              <DxHeaderFilter :visible="true" :allow-search="true" />
              <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[5, 10, 20]"
              />
              <DxGroupPanel :visible="true" />
              <DxGrouping :auto-expand-all="true" />
              <DxPaging :page-size="10" />
              <DxSearchPanel :visible="true" />
              <DxSummary>
                <DxTotalItem
                  column="createdAtUtc"
                  summary-type="count"
                  display-format="{0}"
                />
              </DxSummary>
            </DxDataGrid>
            <br />
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";

import { createStore } from "devextreme-aspnet-data-nojquery";
import ApiService from "../../../core/services/api.service";
import DxHelper from "../../../helpers/dx.helper";

export default {
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      dataSource: {},
      columns: [
        {
          dataField: "createdAtUtc",
          caption: "Date de création",
          dataType: "datetime",
          sortOrder: "desc",
        },
        {
          dataField: "state",
          caption: "Etat",
        },
        {
          dataField: "partnerUserName",
          caption: "Prestataire",
        },
        {
          dataField: "partnerPhoneNumber",
          caption: "Tel",
        },
        
      ],
      requestCount: {},
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Demandes"},
      { title: "Detail"},
      { title: "Prestataire" },
    ]);

    this.dataSource = createStore({
      key: "guid",
      loadUrl: `${ApiService.baseURL}coordinator/v1/requests/requestdetail/${this.$route.params.guid}`,
      onBeforeSend: DxHelper.onBeforeSend,
      onAjaxError: DxHelper.onAjaxError,
    });
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
   
    refresh() {
      this.dataGridInstance.refresh();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
